/**
 *@param {Function} func
 */
export function debounce(func) {
    let timer;

    return function (event) {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(func, 500, event);
    };
}

/**
 *@param {Element} input
 */
export function phoneMask(input) {
    const x = input.value.replace(/(\+38?0?)?\D?/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);
    input.value = '+380 ' + (!x[1] ? '' : '(' + x[1]) + (x[2] ? (') ' + x[2]) : '') + (x[3] ? ('-' + x[3]) : '') + (x[4] ? ('-' + x[4]) : '');
}
export const pageScroll = {
    body: document.querySelector('body'),
    header: document.querySelector('[data-ui-el="header"]'),
    scrollTopPosition: window.scrollY,

    getScrollOffset() {
        return window.innerWidth - document.documentElement.clientWidth;
    },

    lock() {
        this.scrollTopPosition = window.scrollY;
        this.body.style.paddingRight = `${this.getScrollOffset()}px`;
        this.header.style.paddingRight = `${this.getScrollOffset()}px`;
        this.body.classList.add('lock');
        this.body.style.position = 'fixed';
        this.body.style.top = `-${this.scrollTopPosition}px`;
    },

    unlock() {
        setTimeout(() => {
            this.body.classList.remove('lock');
            this.body.style.paddingRight = '';
            this.header.style.paddingRight = '';
        }, 300, this);

        this.body.style.position = '';
        this.body.style.top = '';
        window.scroll(0, this.scrollTopPosition);
    },
};

/**
 *  @param {Element} menuParent
 */
export function menuCollapse(menuParent) {
    if (!menuParent) {
        return;
    }

    const active = menuParent.querySelectorAll('[data-ui-el].active');

    Array.from(active)
        .forEach((elem) => {
            elem.classList.remove('active');
        });

    pageScroll.unlock();
}

const popupClickHandler = (evt) => {
    if (evt.target.closest('[data-ui-el="popup-content"]') && !evt.target.closest('[data-ui-el="popup-close"]')) {
        return;
    }

    popupClose();
};

const windowKeydownHandler = (evt) => {
    if (evt.key !== 'Escape') {
        return;
    }

    evt.preventDefault();
    popupClose();
};

/**
 * @param {Element} popup
 */
export function popupOpen(popup) {
    if (!popup) {
        return;
    }

    popup.classList.add('open');
    popup.addEventListener('click', popupClickHandler);
    window.addEventListener('keydown', windowKeydownHandler);
    pageScroll.lock();
    popup.dispatchEvent(new CustomEvent('popup-open', {
        detail: popup.id,
    }));
}

export function popupClose() {
    const popupOpened = document.querySelector('.popup.open');

    if (!popupOpened) {
        return;
    }

    const popupActiveLinks = document.querySelectorAll('[data-ui-el="popup-link"].active');

    Array.from(popupActiveLinks).forEach((link) => link.classList.remove('active'));
    popupOpened.removeEventListener('click', popupClickHandler);
    window.removeEventListener('keydown', windowKeydownHandler);
    popupOpened.classList.remove('open');
    pageScroll.unlock();
    popupOpened.dispatchEvent(new CustomEvent('collapse'));
}

/**
* @param {Element} link
*/
export function popupInit(link) {
    link.addEventListener('click', (evt) => {
        evt.preventDefault();

        const popupId = link.getAttribute('href');
        const popup = document.querySelector(popupId);

        if (!popup) {
            return;
        }

        popupClose();
        popupOpen(popup);

        if (popupId === '#cart') {
            document.querySelector('[data-ui-el="header"] a[href="#cart"]').classList.add('active');
        } else {
            link.classList.add('active');
        }
    });
}

/**
 * @param {Element} input
 */
export function clearInvalidInputs(input) {
    if (!input.classList.contains('is-invalid')) {
        return;
    }

    input.classList.remove('is-invalid');
    input.nextElementSibling.style.display = null;
}
